import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 11H2V9H14V11ZM14 5H2V7H14V5ZM2 15H10V13H2V15ZM18 13V9H16V13H12V15H16V19H18V15H22V13H18Z" fill={ fill || 'currentColor' } />
    </svg>
);
